import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { ScrollToService } from '../../services/scroll-to/scroll-to.service';

@Component({
  selector: 'button-up',
  templateUrl: './button-up.component.html',
  styleUrls: ['./button-up.component.scss'],
  host: {
    '(window:scroll)': 'onWindowScroll()'
  },
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonUpComponent {
  private scrollToService = inject(ScrollToService);

  windowScrolled = signal(false);

  onWindowScroll(): void {
    this.windowScrolled.set(window.pageYOffset > 100);
  }

  scrollTop(): void {
    this.scrollToService.scrollTo({ container: 'body', offset: 0, duration: 800 });
  }
}
